import { render, staticRenderFns } from "./customer-forms-card.vue?vue&type=template&id=73b76dc2&scoped=true&"
import script from "./customer-forms-card.vue?vue&type=script&lang=js&"
export * from "./customer-forms-card.vue?vue&type=script&lang=js&"
import style0 from "./customer-forms-card.vue?vue&type=style&index=0&id=73b76dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b76dc2",
  null
  
)

export default component.exports